<template>
  <div class="protections-shelf">
    <h2 class="protections-shelf__title title">Conheça as coberturas que vão te deixar tranquilo</h2>
    <carousel v-if="type === 'carousel'" id="protectionsShelf" class="protections-shelf__carousel" :responsive="carouselOptions">
      <li
        class="protections-shelf__item protections-shelf__item--carousel"
        v-for="protection in protections"
        :key="protection.id"
      >
        <a href="javascript:void(0)" @click.prevent="showProtectionDetails($event, protection)" class="protections-shelf__link">
          <figure class="protections-shelf__figure">
            <img
              class="protections-shelf__icon"
              :src="getImage(protection.icon)"
              :alt="protection.alt"
              :title="protection.title"
            />
            <figcaption class="protections-shelf__caption">{{ protection.name }}</figcaption>
          </figure>
        </a>
      </li>
    </carousel>
    <ul v-else-if="type === 'list'" class="protections-shelf__list">
      <li
        class="protections-shelf__item protections-shelf__item--list"
        v-for="protection in protections"
        :key="protection.id"
      >
        <a href="javascript:void(0)" @click.prevent="showProtectionDetails($event, protection)" class="protections-shelf__link">
          <figure class="protections-shelf__figure">
            <img
              class="protections-shelf__icon"
              :src="getImage(protection.icon)"
              :alt="protection.alt"
              :title="protection.title"
              loading="lazy"
            />
            <figcaption class="protections-shelf__caption">{{ protection.name }}</figcaption>
          </figure>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import { mapActions } from "vuex";

export default {
  name: "ProtectionsShelf",
  components: {
    carousel
  },
  props: {
    type: String
  },
  data() {
    return {
      carouselOptions: {
        0: {
          items: 2.5,
          nav: false,
          dots: false,
          loop: true
        },
        600: {
          items: 3
        },
        1025: {
          items: 3,
          loop: false,
          mouseDrag: false
        }
      },
      protections: [
        {
          id: "morte",
          name: "Morte",
          icon: "icone-morte.png",
          alt: "Ícone de cobertura por morte",
          title: "Cobertura por morte - clique e saiba mais",
          link: "/sobre#cobertura-morte"
        },
        {
          id: "ipa",
          name: "Invalidez Permanente (IPA)",
          icon: "icone-invalidez-permanente-total-ou-parcial-por-acidente.png",
          alt:
            "Ícone de cobertura para invalidez permanente total ou parcial por acidente",
          title:
            "Cobertura para Invalidez Permanente Total ou Parcial por Acidente (IPA) - clique e saiba mais",
          link: "/sobre#cobertura-invalidez-permanente"
        },
        {
          id: "saf",
          name: "Assistência Funeral Familiar (SAF)",
          icon: "icone-assistencia-funeral-familiar.png",
          alt: "Ícone de cobertura para assistência funeral familiar",
          title:
            "Cobertura para Assistência funeral familiar (SAF) - clique e saiba mais",
          link: "/sobre#cobertura-assistencia-funeral"
        }
      ]
    };
  },
  methods: {
    ...mapActions(["setLightbox"]),
    getImage: imageId => require(`../../assets/img/${imageId}`),
    showProtectionDetails: function(event, protection) {
      const content = {
        morte: "<p>Se você vier a falecer por causas naturais ou acidentais, seus beneficiários vão receber a indenização estipulada no contrato.</p>",
        ipa: "<p>Você receberá o valor contratado em caso de acidente que cause a perda, redução ou incapacidade de funcionamento de um órgão ou membro, parcial ou totalmente, de forma definitiva.</p>",
        saf:"<p>Com o Seguro de Assistência Funeral (SAF) você tem a certeza de que elas terão apoio para cuidar das providências necessárias neste momento tão difícil. Ao optar pelo seguro de assistência funeral familiar, seu cônjuge e dependentes menores de 21 anos também estão cobertos por este serviço.</p>"
      };
      const payload = {
        show: true,
        title: protection.name,
        content: content[protection.id]
      };
      this.setLightbox(payload);
    }
  }
};
</script>

<style lang="scss">
.protections-shelf {
  margin: $space__lg 0;

  &__title {
    margin-bottom: $space__md;
  }

  &__carousel {
    margin-left: $space__sm;

    @include breakpoint($desk__min--sm) {
      max-width: 70%;
      margin: 0 auto;
    }
  }

  &__list {
    max-width: 80%;
    margin: 0 auto;

    @include breakpoint($tablet__min--sm) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__link {
    text-decoration: none;
  }

  &__item {
    @extend %card;
    height: 100px;
    margin-right: $space__xs;
    margin-left: $space__xs;
    background: $color__yellow-light;
    transition: all 300ms ease-in;
    cursor: pointer;

    @include breakpoint($desk__min--sm) {
      height: 170px;
      margin-right: $space__md;
      margin-left: $space__md;
    }

    &:hover {
      font-size: 1.2em;
      transform: scale(1.1);
    }

    &--list {
      flex: 0 0 30%;
    }

    a {
      width: 100%;
    }
  }

  &__figure {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  &__icon {
    max-width: 70px;
    margin-bottom: $space__md;
  }

  &__caption {
    color: $color__white;
    text-align: center;
    font-weight: 700;

    @include breakpoint($desk__min--sm) {
      margin-left: $space__md;
    }
  }
}
</style>